import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/administration/users/")({
  beforeLoad: () => {
    throw redirect({ to: "/workspace/users" });
  },
});
